// Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeRegister,
  postJwtRegister,
  postJwtRegister2,
} from "../../../helpers/fakebackend_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange
} from "./reducer";

export const registerUser = (user) => async (dispatch) => {
  try {
    dispatch(apiErrorChange(false));

    // Use postJwtRegister2 instead of postJwtRegister
    const response = await postJwtRegister(user);

    if (response && response.ok) {
      dispatch(registerUserSuccessful(response.data));
    } else {
      const errorData = await response.json();

      let errorMessage;
      if (Array.isArray(errorData.password1)) {
        errorMessage = `Password: ${errorData.password1[0]}`;
      } else if (Array.isArray(errorData.username)){
        errorMessage = `Username: ${errorData.username[0]}`;
      } else if (Array.isArray(errorData.email)){
        errorMessage = `Email: ${errorData.email[0]}`;
      }else if ('message' in errorData) {
        errorMessage = errorData.message;
      } else {
        errorMessage = "Registration failed. Please try again.";
      }
      dispatch(registerUserFailed(errorMessage));
    }
  } catch (error) {
    const errorMessage = error.message || "An unexpected error occurred";
    dispatch(registerUserFailed(errorMessage));
    dispatch(apiErrorChange(true));
  }
};

export const resetRegisterFlag = () => (dispatch) => {
  try {
    dispatch(resetRegisterFlagChange());
  } catch (error) {
    dispatch(apiErrorChange(true));
  }
};

export const apiError = (hasError) => (dispatch) => {
  dispatch(apiErrorChange(hasError));
};
